module.exports = require('./lib/static/prefixAll')



/*****************
 ** WEBPACK FOOTER
 ** /Users/kylemathews/programs/typography.js/packages/typography-design-tools/~/inline-style-prefixer/static.js
 ** module id = 466
 ** module chunks = 0
 **/